import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLoadingStore = defineStore('loading', () => {
  const loadingStates = ref<Record<string, boolean>>({})
  const globalLoading = ref(false)

  const startLoading = (key: string = 'global') => {
    if (key === 'global') {
      globalLoading.value = true
    } else {
      loadingStates.value[key] = true
    }
  }

  const stopLoading = (key: string = 'global') => {
    if (key === 'global') {
      globalLoading.value = false
    } else {
      loadingStates.value[key] = false
    }
  }

  const isLoading = (key: string = 'global') => {
    if (key === 'global') {
      return globalLoading.value
    }
    return loadingStates.value[key] || false
  }

  const clearAll = () => {
    loadingStates.value = {}
    globalLoading.value = false
  }

  return {
    loadingStates,
    globalLoading,
    startLoading,
    stopLoading,
    isLoading,
    clearAll
  }
})
